import script from "./ChatbotDialognew.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatbotDialognew.vue?vue&type=script&setup=true&lang=js"

import "./ChatbotDialognew.vue?vue&type=style&index=0&id=449463dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449463dd"]])

export default __exports__